import CompLayout from "@/pcomponents/comp/layout/layout";
import { useState } from 'react';
import SuppyListArea from "@/pages/comp/supply/supply/common/supply_list";
import SupplyMultyAddArea from "@/pages/comp/supply/supply/common/muly_add_list";
import UserSupplyListArea from "@/pages/comp/supply/supply/common/user_supply_list";
import SelectBoxBar from "@/pcomponents/common/crud/write/select_box_bar";

function SuppyMain() {
  const [select_tab, set_select_tab] = useState("supply_history");//muly_add
  const [select_tab_arr, set_select_tab_arr] = useState([
    // { value: "supply_list", text: "수납" },
    { value: "supply_history", text: "수납관리" },
    { value: "muly_add", text: "수납생성" }
  ]);

  return (
    <CompLayout>
      <SuppyListArea></SuppyListArea>
      {/* <div>
        <div style={{display:"inline-block",minWidth:"200px"}}>
          <SelectBoxBar
            valueTextArr={select_tab_arr}
            value={select_tab}
            name="select_tab"
            on_change={(inData:any) => {
              set_select_tab(inData.value);
            }}
            is_same_value_empty={false}
            is_arr_value={false}
            style_type="wide"
          ></SelectBoxBar>
        </div>
      </div> */}
      {/* {select_tab == "supply_list" &&
        <UserSupplyListArea></UserSupplyListArea>
      }
      {select_tab == "supply_history" &&
        <SuppyListArea></SuppyListArea>
      }
      {select_tab == "muly_add" &&
        <SupplyMultyAddArea></SupplyMultyAddArea>
      } */}
    </CompLayout>
  );
}

export default SuppyMain;